import type { FC } from "react";
import React from "react";

import HeaderRightButtonCircle from "../../../general/RightButtonCircle/HeaderRightButtonCircle";
import { createDisplayNameForHeaderClose } from "../../utils/createDisplayName";
import { createTestIdForHeaderClose } from "../../utils/createTestId";

import type {
    HeaderRightButtonProps,
    ICoreHeaderTextView,
} from "../../../general/CoreHeader/types";

const RIGHT_BUTTON_CIRCLE_TEST_ID = createTestIdForHeaderClose(
    "right-button-circle",
);

export const HeaderCloseRightButtonCircle: FC<HeaderRightButtonProps> = (
    props,
) => {
    const { "data-tsid": tsid = RIGHT_BUTTON_CIRCLE_TEST_ID, ...restProps } =
        props as HeaderRightButtonProps & ICoreHeaderTextView;

    return (
        <HeaderRightButtonCircle
            {...restProps}
            icon="glyph_close_16_20"
            data-tsid={tsid}
        />
    );
};

HeaderCloseRightButtonCircle.displayName =
    createDisplayNameForHeaderClose("RightButtonCircle");

export default HeaderCloseRightButtonCircle;
